import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import newsApi from '../../api/newsApi';

export const updateNews = createAsyncThunk('news/updateNews', async (params, thunkAPI) => {
    const response = await newsApi.updateNews(params)

    return response
})

export const getSingleNews = createAsyncThunk('news/getSingleNews', async (params, thunkAPI) => {
    const response = await newsApi.getSingleNews(params)
    return response.news
})

export const getNews = createAsyncThunk('news/getNews', async (params, thunkAPI) => {
    const response = await newsApi.getNews(params)

    return response
})

export const postNews = createAsyncThunk('news/postNews', async (params, thunkAPI) => {
    const response = await newsApi.postNews(params)

    return response
})

export const deleteNews = createAsyncThunk('news/deleteNews', async (params, {dispatch}) => {
    const response = await newsApi.deleteNews(params)

    return response.deletedNews
})

const newsSlice = createSlice({
    name: 'news',
    initialState: {
        isLoading: true,
        news: {},
        totalRows: 0,
        currentNews: {},
        currentNewsLoading: true
    },
    reducers: {
        updateLikes: (state, action) => {
            return {
                ...state,
                currentNews: {
                    ...state.currentNews,
                    likes: [...action.payload]
                }
            }
        },
        updateComments: (state, action) => {
            return {
                ...state,
                currentNews: {
                    ...state.currentNews,
                    comments: [action.payload, ...state.currentNews.comments]
                }
            }
        },
        
        updateCommentLikes: (state, action) => {
            return {
                ...state,
                currentNews: {
                    ...state.currentNews,
                    comments: state.currentNews.comments.map(comment => comment._id === action.payload._id ? comment = action.payload:comment)
                }
            }
        },

        updateReplies: (state, action) => {
            return {
                ...state,
                currentNews: {
                    ...state.currentNews,
                    comments: state.currentNews.comments.map(comment => comment._id === action.payload ? {...comment, replies: comment.replies+1}:comment)
                }
            }
        }

    },
    extraReducers: {
        // [getNews.pending]: state => {
        //     state.isLoading = true
        // },
        [getNews.rejected]: state => {
            state.isLoading = false
            state.news = {}
            state.totalRows = 0
        },
        [getNews.fulfilled]: (state, action) => {
            state.isLoading = false
            state.news = action.payload.news
            state.totalRows = action.payload.totalRows
        },
        //
        [getSingleNews.pending]: (state, action) => {
            state.currentNewsLoading = true
        },

        [getSingleNews.rejected]: (state, action) => {
            state.currentNews = {}
            state.currentNewsLoading = false
        },

        [getSingleNews.fulfilled]: (state, action) => {
            state.currentNews = action.payload
            state.currentNewsLoading = false
        },
    }
});

const { reducer, actions } = newsSlice

export const {updateLikes,updateComments,updateCommentLikes, updateReplies} = actions

export default reducer